<template>
  <div class="row-history">
    <el-container class="row-con">
      <el-header style="visibility:hidden;" class="m-filter">
        <div class="wp">
          <div class="filter">
          </div>
        </div>
      </el-header>

      <div class="total">
        <div class="total_top">
          <div class="texts">
            <h3>总桩数</h3>
          </div>
          <div class="bottom">
            <div class="value">{{totalNum.totalPileNum|fil}}根</div>
          </div>
        </div>

        <div class="total_top">
          <div class="texts">
            <h3>总延米</h3>
          </div>
          <div class="bottom">
            <div class="value">{{totalNum.totalDepth|numfilters}}m</div>
          </div>
        </div>
        <div class="total_top">
          <div class="texts">
            <h3>总浆量</h3>
          </div>
          <div class="bottom">
            <div class="value">{{totalNum.totalCumulativePulp|numfilters}}L</div>
          </div>
        </div>
        <div class="total_top">
          <div class="texts">
            <h3>总灰量</h3>
          </div>
          <div class="bottom">
            <div class="value">{{totalNum.totalCumulativeAsh|num}}t</div>
          </div>
        </div>
        <div class="total_top">
          <div class="texts">
            <h3>平均灰量</h3>
          </div>
          <div class="bottom">
            <div class="value">{{totalNum.avgAsh|numfilters}}kg/m</div>
          </div>
        </div>
      </div>

      <el-main style="visibility:hidden;" class="m-table-main m-table-alertInfo">
        <!-- <div class="inner" style="width:100%;height:90%">
          <div ref="myChart01" :style="{ width: '100%', height: '100%' }"></div>
        </div> -->
      </el-main>
    </el-container>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['totalNum', 'deviceList', 'meter', 'pile'],
  data() {
    return {
      device: '',
      startDate: '',
      endDate: ''
    }
  },
  filters: {
    fil(val) {
      if (!val) {
        return 0
      } else {
        return val
      }
    },
    datafilters(val) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    numfilters(val) {
      if (val == undefined) {
        return 0
      } else {
        return parseFloat(val).toFixed(2)
      }
    },
    num(val) {
      if (val == undefined) {
        return 0
      } else {
        return parseFloat(val / 1000).toFixed(2)
      }
    }
  },
  methods: {
    query() { }
  }
}
</script>
